import Vue from 'vue';

const success = (context, response) => {
    context.tasks = response.tasks;
    context.loading = false;
};

const failed = (context, error) => {
    context.loading = false;
};

export default (context, start = null, end = null, rentals = []) => {
  return Vue.$http.get(`tasks?start=${start}&end=${end}&rentals=${rentals}`)
    .then(response => {
      success(context, response.data);
    }).catch(error => {
      failed(context, error);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/task/get.js